<template>
  <OptionsList :active="active" :select="select" :options="options" />
</template>

<script setup>
import OptionsList from "@/pages/ListingsPage/filters/mobile/OptionsList.vue"
</script>

<script>
import { categories } from "@/lib/ListingFilters"
import isEqual from "lodash/isEqual"
import { mapActions, mapState } from "vuex"

export default {
  name: "CategoriesSelectFilter",
  data() {
    return {
      allArtOption: "All Art",
      filterType: "mediums",
    }
  },
  methods: {
    active(filter) {
      return this.activeOption === filter
    },
    select(filter) {
      if (filter === this.activeOption) {
        this.selectCategory(this.allArtOption)
      } else {
        this.selectCategory(filter)
      }
    },
    ...mapActions("filter", ["selectCategory", "mergeFilter"]),
  },
  computed: {
    activeOption() {
      const mediums = this.filters["mediums"]

      if (mediums.length === 0) {
        return this.allArtOption
      }

      let active

      this.options.some(({ value }) => {
        if (categories[value].length === mediums.length) {
          if (isEqual(categories[value], mediums)) {
            active = value
            return true
          }
        }
      })

      return active
    },
    options() {
      return Object.keys(categories).map((el) => ({ title: el, value: el }))
    },
    ...mapState("filter", ["filters"]),
  },
}
</script>
